import styled from "styled-components";
import { Colors } from "../../config/Constants";
interface Props {
  onRefresh: () => void;
}
const LinkButton = ({ onRefresh }: Props) => {
  return <StyledLinkButton onClick={onRefresh}>Refresh</StyledLinkButton>;
};

const StyledLinkButton = styled.button`
  background: transparent;
  border: none;
  color: ${Colors.coastlineBlue};
  font-family: Poppins-Medium;
  text-decoration: underline;
  font-size: 0.875;
`;

export default LinkButton;
